import React from 'react';
import { IconType } from 'react-icons';
import { LuHouse } from 'react-icons/lu';

interface SubnavProps {
    subnavItems: {
        order?: number;
        label?: React.ReactNode;
        icon?: IconType;
        identifier: string;
        main?: boolean;
    }[];
    onChange: (key: string) => void;
    activeSubsection?: string;
}

export const Subnav = (props: SubnavProps) => {
    return (
        <div id='subnav' className='w-full'>
            <div className="relative">
                <ul className="relative flex flex-wrap gap-1.5 p-1.5 list-none rounded-xl bg-background-surface" data-tabs="tabs" role="list">
                    {props.subnavItems.map((key) => {
                        const Icon = key.icon;
                        return (
                            <li
                                className='z-30 flex-auto text-center'
                                data-testid={`nav-item-${key.identifier}`}
                                onClick={() => props.onChange(key.identifier)}
                                key={key.identifier}>
                                <a className={`z-30 flex items-center justify-center gap-2 w-full px-2 py-2 text-sm mb-0 transition-all ease-in-out border-0 rounded-lg cursor-pointer h-full ${props.activeSubsection === key.identifier.toLowerCase() ? 'bg-brand-primary text-always-white' : 'bg-inherit text-brand-muted hover:bg-brand-primary/20'}`}
                                data-tab-target={key.identifier} role="tab" aria-selected={props.activeSubsection === key.identifier.toLowerCase()}>
                                    {Icon ? <Icon /> : <LuHouse />}
                                    {key.label ?? 'Basic'}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};